import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { spacing } from "#app/theme/v1/spacing";
import { PageLayout } from "#shared/layouts/PageLayout";
import { ROUTES } from "#shared/routes";
import { useAnalytics, AnalyticsEvent } from "#shared/useAnalytics";
import { links } from "#shared/view/components/AppShell/Navbar";
import { Flex } from "#shared/view/components/Flex";
import { SectionWrapper } from "#shared/view/components/SectionWrapper";
import { Stack } from "#shared/view/components/Stack";
import { Button } from "#shared/view/designSystem/Button";

const settingsLinks = links.find((link) => link.href === ROUTES.partnerSettings) || {
  children: [],
};

const navLinks = settingsLinks.children || [];

export const SettingsPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    const section = pathname.replace(`${ROUTES.partnerSettings}/`, "").split("/")[0];
    if (section) {
      analytics.capture(AnalyticsEvent.SettingsPageViewed, { section });
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <PageLayout title="Préférences de l'entreprise">
      <Flex>
        <SectionWrapper
          style={{
            marginTop: spacing.sm,
            marginBottom: spacing.sm,
            height: "100%",
          }}
        >
          <Stack align="flex-start" gap="xxs">
            {navLinks.map((link) => (
              <Button
                variant={pathname.includes(link.href) ? "light" : "subtle"}
                color="grey"
                key={link.label}
                onClick={() => navigate(link.href)}
              >
                {link.label}
              </Button>
            ))}
          </Stack>
        </SectionWrapper>

        <Outlet />
      </Flex>
    </PageLayout>
  );
};
